/**
 * Datas vêm da API como "2026-10-01" ou "2026-10-01T03:00:00.000000Z" (cast `date` do Laravel,
 * serializado em UTC a partir de America/Fortaleza). Os 10 primeiros caracteres são sempre o dia
 * certo, porque o fuso é negativo — não passar por `new Date`, que desloca o dia.
 */
export function dataIso(valor) {
  return valor ? `${valor}`.substring(0, 10) : null;
}

export function formatarData(valor) {
  const data = dataIso(valor);
  return data ? data.split("-").reverse().join("/") : "- - -";
}

/**
 * Período com pré-matrícula fica bloqueado para edição: só pode ser ativado ou desativado.
 * A API devolve `pre_matriculas_count` na listagem e em todas as respostas do período.
 */
export function periodoEstaCongelado(periodo) {
  return Number(periodo.pre_matriculas_count) > 0;
}

/**
 * formapagamentos.codigo do Boleto Bancário (código fiscal, igual em todo ambiente). Fica fora do
 * pagamento no caixa da pré-matrícula: o boleto pago chega pelo webhook do Sicoob.
 * Mesmo valor de CodigoFormaDePagamentoEnum::BoletoBancario na API.
 */
export const CODIGO_DO_BOLETO = 15;

export const STATUS_PRE_MATRICULA = {
  BOLETO_PENDENTE: { texto: "Boleto pendente", cor: "orange" },
  BOLETO_PAGO: { texto: "Boleto pago", cor: "success" },
  MATRICULADO: { texto: "Matriculado", cor: "primary" },
};

/**
 * O interceptor do Axios rejeita com o corpo da resposta: `{ message, errors }` do Form Request,
 * ou o conteúdo de `error` para RegraDeNegocioException. Os dois têm `message`.
 * O throttle do Laravel (429) responde em inglês.
 */
export function mensagemDeErro(error) {
  const mensagem = error && error.message;
  if (!mensagem) return "Não foi possível concluir agora. Tente novamente em instantes.";
  if (mensagem === "Too Many Attempts.") {
    return "Limite de tentativas excedido. Aguarde um minuto e tente novamente.";
  }
  return mensagem;
}

export const somenteDigitos = (valor) => `${valor || ""}`.replace(/\D/g, "");

export function formatarCpf(cpf) {
  return somenteDigitos(cpf).replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") || "- - -";
}
